import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en/translation.json';
import vi from './locales/vi/translation.json';
import { storage, STORAGE_KEYS } from './utils/storage';

export type AppLanguage = 'en' | 'vi';

const getInitialLanguage = (): AppLanguage => {
  if (typeof window === 'undefined') return 'vi';
  const storedLanguage = storage.get<unknown>(STORAGE_KEYS.LANGUAGE);
  return storedLanguage === 'en' || storedLanguage === 'vi' ? storedLanguage : 'vi';
};

const initialLanguage = getInitialLanguage();

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en
      },
      vi: {
        translation: vi
      }
    },
    lng: initialLanguage,
    fallbackLng: 'vi',
    supportedLngs: ['vi', 'en'],
    interpolation: {
      escapeValue: false // React đã tự xử lý XSS
    },
    react: {
      useSuspense: false
    }
  });

const persistLanguage = (language: string) => {
  const normalizedLanguage: AppLanguage = language.startsWith('en') ? 'en' : 'vi';
  if (typeof window !== 'undefined') storage.set(STORAGE_KEYS.LANGUAGE, normalizedLanguage);
  if (typeof document !== 'undefined') document.documentElement.lang = normalizedLanguage;
};

persistLanguage(initialLanguage);
(i18n as unknown as {
  on: (event: 'languageChanged', listener: (language: string) => void) => void;
}).on('languageChanged', persistLanguage);

export default i18n;
